<template>
  <div class="mycourses-wrapper">
    <section class="sajilo-section">
        <div class="container">
          <div class="mycourses__list courses__list">
            <v-row>
              <v-col cols="12" sm="6" lg="4" >
                <article class="featured_courses__heading-content">
                  <h2 class="featured_courses__title">All <span>Teacher</span></h2>
                  <!-- <button class="button button_md button_blue">View All Courses</button> -->
                  <span class="icon-zigzag-line-alt"></span>
                </article>
              </v-col>

              <v-col cols="12" sm="6" lg="4" v-for="(course,i) in lecturer" :key="i" >
                <div class="featured_courses_card_wrapper">
                  <lecturer-card :course="course"></lecturer-card>
                </div>
              </v-col>
            </v-row>

            <!-- <div class="course-list__pagination"  v-if="count">
              <div class="text-right">
                <CoursePagination :page="dataOption" class="justify-end"></CoursePagination>
              </div>
            </div> -->
          </div>
        </div>
    </section>
    <KeepLearning></KeepLearning>
  </div>
</template>

<script>
import LecturerCard from '@/components/Courses/Lecturer';
// import CoursePagination from "@/components/Courses/CoursePagination.vue";
import KeepLearning from "@/components/KeepLearning/KeepLearning.vue";
export default {
  name: 'AllTeacher',
  data () {
    return {
      lecturer: [],
    //   count: null,
    //   requestData: {
    //     page: 1,
    //     page_size: 8,
    //   },
    //   dataOption: {
    //     page: 1,
    //     length: null
    //   }
    }
  },
  components: {
    LecturerCard,
    // CoursePagination,
    KeepLearning
  },
  
  mounted () { 
      // this.getAllCourse();
    //   this.pagination({page:this.$route.query.page, page_size: this.requestData.page_size})
    this.getLecture();
  },
  methods: {
    // async getAllCourse() {
    //   let payload = {...this.requestData}
      
    //   await this.$api.getWithPayload(`course/paginated/`, payload).then(res => {
    //       this.courses = res.results
    //       this.count= res.count
    //       let page = parseInt(this.requestData.page)
    //       this.dataOption.page = page
    //       if(res.count > this.requestData.page_size) {
    //         let result = res.count - this.requestData.page_size
    //         this.dataOption.length = result;
    //       }
    //       else {
    //         this.dataOption.length = 1;
    //       }
    //       // this.$router.push(`/allcourse?page=${this.requestData.page}&page_size=${this.requestData.page_size}`)
    //   })
    // },
    // async pagination(val) {
    //   // console.log(val)
    //   this.$bus.emit('loading-toggle')
    //   let page = val.page
    //   let payload = {page: page, page_size:this.requestData.page_size}
    //   await this.$api.getWithPayload(`course/paginated/`, payload).then(res => {
    //       this.courses = res.results
    //       this.count= res.count
    //       // this.dataOption.page = page
    //       // console.log('work')
    //       if(res.count > this.requestData.page_size) {
    //         this.dataOption.length = res.total_pages
    //       }
    //       else {
    //         this.dataOption.length = 1;
    //       }
    //       this.$router.push(`/allcourse/?page=${val.page}&page_size=${val.length}`)
    //       // this.$bus.emit('loading-toggle')
    //   })
    // }
    async getLecture() {
      await this.$api.get(`authuser/lecturer-list/`).then(res => {
        this.lecturer = res.results;
      })
    },
  },
  watch: {
    // dataOption: {
    //   handler(val) {
    //     this.pagination(val);
    //   },
    //   deep: true
    // }
    // '$route.query.page': {
    //   handler(val) {
    //     this.pagination(val);
    //   },
    //   deep: true
    // },
  },
}
</script>

